import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { ROUTE_NAMES } from "@bakbak/common";
import {
  RegisterMutation_register_user,
  RegisterController,
  withSignS3,
  IWithSignS3
} from "@bakbak/controller";

import { withAppContext, AppContextProps } from "../../../context/AppContext";
import { RegisterView } from "./RegisterView";

export class RegisterC extends React.PureComponent<
  RouteComponentProps & AppContextProps & IWithSignS3
> {
  onComplete = (user: RegisterMutation_register_user | null) => {
    if (user) {
      this.props.context.updateLoggedUser(user);
      this.props.history.push(ROUTE_NAMES.HOME);
    } else {
      // TODO: did not get any response back.
    }
  };

  onCancel = () => {
    this.props.history.push(ROUTE_NAMES.HOME);
  };

  gotoLogin = () => {
    this.props.history.push(ROUTE_NAMES.LOGIN);
  };

  render() {
    return (
      <RegisterController>
        {({ submit }) => (
          <RegisterView
            submit={submit}
            gotoLogin={this.gotoLogin}
            onComplete={this.onComplete}
            onCancel={this.onCancel}
            signS3Mutate={this.props.signS3}
          />
        )}
      </RegisterController>
    );
  }
}

export const RegisterConnector = withAppContext(withSignS3(RegisterC));



// WEBPACK FOOTER //
// ./src/modules/auth/register/RegisterConnector.tsx